<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Haben Sie Beschwerden in der Beckenregion?</p>
  <p>Zum Beispiel: Dammbereich, Geschlechtsorgane, Blasenregion, Enddarm und/oder Steißbein.</p>
  <p class="italic">
    Hinweis: Die Schmerzen können in der Stärke variieren: Von einem unbestimmten Unwohlsein/gar
    kein richtiger Schmerz – bis hin zu unerträglichen Schmerzen. Die Schmerzqualität kann dumpf
    drückend, aber auch scharf, brennend und elektrisierend sein.
  </p>
</QuestionFrame>
